import {useAppState} from 'store/utils';

export function useMoneyBoxStore(): MoneyBoxState {
  return useAppState().moneyBox;
}
